<app-dashboard-sidemenu></app-dashboard-sidemenu>


<!-- Start Main Content Wrapper Area -->
<div class="main-content d-flex flex-column">
    <div *ngFor="let Content of breadcrumb;" class="breadcrumb-area">
        <h1>{{Content.title}}</h1>
        <ol class="breadcrumb">
            <li class="item">
                <a routerLink="/">Home</a>
            </li>
            <li class="item">
                <a routerLink="/dashboard">
                    {{Content.subTitle}}
                </a>
            </li>
            <li class="item">{{Content.title}}</li>
        </ol>
    </div>
    <div class="text-right add-listings-btn">
        <div class="form-group">
            <button type="submit" class="submit_btn m-0" routerLink="/tool-shifting-form" style="margin-right:5px !important;"
            *ngIf="(role.roleName === 'Admin' || role.checker1 == true)">
            Add
        </button>
        	<button type="submit" class="submit_btn m-0" 
				style="margin-right:5px !important;" (click)="generatetoolloan()"
				*ngIf="(role.roleName === 'Supplier' || role.roleName === 'Admin')">
				Generate Tool Agreement
			</button>
            <!-- <button type="submit" class="submit_btn m-0" (click)="sendtohealthcheckup()"
                *ngIf="role.roleName == 'Supplier' ||role.roleName ==='Admin'">
                Tool Health Checkup
            </button> -->
        </div>
    </div>
    <p-table #dt2 [value]="ToolshiftingData" [rows]="10" responsiveLayout="scroll" [showCurrentPageReport]="true"
        [rowsPerPageOptions]="[10,20,30,50]" [paginator]="true" currentPageReportTemplate="Showing {first} to
{last} of {totalRecords} entries" [filterDelay]="0"
        [globalFilterFields]="['businessUnit', 'supplierName','currencyName','packageNumber','orderNumber','jdecode','assetCode']">
        <ng-template pTemplate="caption">
            <div class="d-flex align-items-center " style="width: 100%;">

                <span class="p-input-icon-left d-flex align-items-center">
                    <i class="pi pi-search"></i>
                    <input [(ngModel)]="filterval" (input)="dt2.filterGlobal($event.target.value,
            'contains')" pInputText type="text" placeholder="Global Search">
                    <p-button (click)="reset(dt2)" type="button" class="ml-2" icon="bx bx-reset"></p-button>
                </span>

            </div>
        </ng-template>


        <ng-template pTemplate="header">
            <tr>
                <th>S.No.</th>
                <th *ngIf="role.roleName == 'Supplier'">Action</th>
                <th>Asset Code</th>
                <!-- <th>Tool New Or Shifted</th> -->
                <th>BU</th>
                <th>Business Unit</th>
                <th>PO Type</th>
                <th>PO No.</th>
                <!-- <th>Tool Description</th> -->
                <th>Supplier Name</th>
                <th>Supplier Code</th>
               <th>Remarks</th>
                <th>RMG</th>
                <Th>Lr Copy</Th>
                <th>DC</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-tool let-i="rowIndex">
            <tr class="p-selectable-row">
                <td>{{i+1}}</td>
                <td *ngIf="role.roleName == 'Supplier'">
                <ng-container
							>
							<input type="checkbox" [(ngModel)]="tool.selected"
								[disabled]="tool.disabled||tool.documentSigned"
								style="cursor: pointer;">
						</ng-container>
                        </td>
                <td>{{tool.assetCode ||'-'}}</td>
                <td>{{tool.bu || '-'}}</td>
                <td>
                    {{tool.businessUnit || '-'}}
                </td>
                <td>{{tool.poType || '-'}}</td>
                <td>
                    <span>{{tool.orderNumber|| '-'}}</span>
                </td>
                <!-- <td>
                <span>
                    {{tool.itemDescription }}
                </span>
            </td> -->
                <td>
                    <span>
                        {{tool.supplierName || '-' }}
                    </span>
                </td>
                <td> <span>{{tool.jdecode || '-' }}</span></td>

                <!-- <td>
                <span>
                    {{tool.assetCode }}
                </span>
            </td> -->

                <td>
                <span>{{tool.remarks}}</span>
            </td>
          <td><span><a [href]="tool.rmgOfIdexToNewSuppliers" target="_blank"
                                    [download]="tool.rmgOfIdexToNewSuppliers">Preview</a></span></td>
            <td><span><a   [href]="tool.lrCopyOfTransporters" target="_blank"
                                    [download]="tool.lrCopyOfTransporters">Preview</a></span></td>
              <!-- <td>
                {{tool.dcOfExistingSuppliers}}
            </td> -->
               <td><span><a [href]="tool.dcOfExistingSuppliers" target="_blank"
                                    [download]="tool.dcOfExistingSuppliers">Preview</a></span></td>
               <!-- <td>
                {{tool.rmgOfIdexToNewSuppliers}}
            </td> -->
            
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5">No data found.</td>
            </tr>
        </ng-template>
    </p-table>
    <app-dashboard-navbar></app-dashboard-navbar>
</div>

<!-- <p-dialog [(visible)]="checker1Modal" header="Checker 1 Verifcation" [modal]="true" [style]="{width: '45vw'}" [draggable]="false" [resizable]="false" >
    <div class="container authentication">
        <label for="remark">Remark</label>
        <textarea id="remark" type="text"  class="form-control"></textarea>
    </div>
    <br>
    <div class="col-lg-12">
        <div class="add-listings-btn" style="text-align: right">
            <button class="mr-2 success-btn" type="submit" (click)="btnClick('approve')"
                style="background: #40b340; color: white;">
                Approve
            </button>
            <button class="mr-2 reject-btn" type="submit" (click)="btnClick('reject')"
                style="background: #e34747; color: white;">
                Rework
            </button>
        </div>
    </div>
</p-dialog> -->
